import { cn } from "@/lib/utils";

interface SectionProps extends React.ComponentProps<"section"> {
  title?: string;
  description?: string;
}

function Section({
  title,
  description,
  className,
  children,
  ...props
}: SectionProps) {
  return (
    <section
      className={cn("space-y-[var(--space-5)]", className)}
      {...props}
    >
      {(title || description) && (
        <div>
          {title && (
            <h2 className="font-heading text-[length:var(--font-size-xl)] font-[number:var(--font-weight-bold)] tracking-[var(--letter-spacing-tight)] text-[var(--color-text-primary)]">
              {title}
            </h2>
          )}
          {description && (
            <p className="mt-[var(--space-1)] text-[length:var(--font-size-base)] text-[var(--color-text-muted)]">
              {description}
            </p>
          )}
        </div>
      )}
      {children}
    </section>
  );
}

export { Section };
export type { SectionProps };
